export const Search = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 21L29.2996 29.2996" stroke="currentColor" stroke-width="2"/>
<circle cx="14" cy="14" r="10" stroke="currentColor" stroke-width="2"/>
</svg>`;
